import * as zip from "@zip.js/zip.js";


export const unzip = async (zipFileBlob, onProgress) => {
    const zipReader = new zip.ZipReader(new zip.BlobReader(zipFileBlob));
    const entries = await zipReader.getEntries({
        onprogress: function(index,max) {
            // console.log('opening zip', index/max);
        }
    });

    const audioFileArray = [];
    // console.log(entries);

    await Promise.all(entries.filter(entry=> !entry.filename.includes('__MACOSX')).map(async (entry, index) => {
        // console.log(entry.filename);
        const unzippedBlob = await entry.getData(new zip.BlobWriter(), {
            onprogress: onProgress
        });
        audioFileArray[index] = unzippedBlob;
    }));
    // for (const entry of entries) {
    //     if (!entry.filename.includes('__MACOSX')) {
    //         try {
    //             const unzippedBlob = await entry.getData(new zip.BlobWriter(), {
    //                 onprogress: onProgress
    //             });
    //             const blobArrayBuffer = await unzippedBlob.arrayBuffer();
    //             console.log(blobArrayBuffer);
    //             audioFileArray.push(blobArrayBuffer);
    //         } catch (e) {
    //             console.log(e);
    //         }
            
            
    //     }
        
    // }
    await zipReader.close();
    return audioFileArray;
  }

  export const unzipArrayBuffer = async (zipFileArrayBuffer, onProgress) => {
    const zipReader = new zip.ZipReader(new zip.Uint8ArrayReader(new Uint8Array(zipFileArrayBuffer)));
    const entries = await zipReader.getEntries({
        onprogress: function(index,max) {
            // console.log('opening zip', index/max);
        }
    });
    const audioFileObject = {};
    await Promise.all(entries.filter(entry=> !entry.filename.includes('__MACOSX')).map(async (entry, index) => {
        // console.log(entry.filename);
        const unzippedBlob = await entry.getData(new zip.BlobWriter(), {
            onprogress: onProgress
        });
        audioFileObject[entry.filename.split('.')[0]] = unzippedBlob;
    }));
    await zipReader.close();
    return audioFileObject;
  }


  export const createSessionZip = async (sessionJSON, userAudioObjects) => {
    const blobWriter = new zip.BlobWriter("application/zip");
    const zipWriter = new zip.ZipWriter(blobWriter);

    await zipWriter.add(`${sessionJSON.id}.json`, new zip.TextReader(JSON.stringify(sessionJSON)));

    for (const audioFileArrayBuffer of userAudioObjects) {
        await zipWriter.add(audioFileArrayBuffer.fileName, new zip.Uint8ArrayReader(new Uint8Array(audioFileArrayBuffer.arrayBuffer)));
    }
    await zipWriter.close();

    // get the zip file as a Blob
    const blob = blobWriter.getData();
    return blob;
  }

  export const createSetlistZip = async (sessionZips) => {
    const blobWriter = new zip.BlobWriter("application/zip");
    const zipWriter = new zip.ZipWriter(blobWriter);

    for (const sessionId of Object.keys(sessionZips)) {
        await zipWriter.add(`${sessionId}.session`, new zip.BlobReader(sessionZips[sessionId]));
    }
    await zipWriter.close();

    // get the zip file as a Blob
    const blob = blobWriter.getData();
    return blob;
  }

  export const openSessionZip = async (sessionZipBlob) => {
    const zipReader = new zip.ZipReader(new zip.Uint8ArrayReader(new Uint8Array(sessionZipBlob)));

    const entries = await zipReader.getEntries();

    let session = {};
    let audioAssets = {};

    await Promise.all(entries.filter(entry=> !entry.filename.includes('__MACOSX')).map(async (entry, index) => {
        if (entry.filename.includes('.json')) {
            const sessionBlob = await entry.getData(new zip.BlobWriter("text/plain"));
            session = JSON.parse(await sessionBlob.text());
        } else {
            const audioAsset = await entry.getData(new zip.BlobWriter("audio/wav"));
            audioAssets[entry.filename] = await audioAsset.arrayBuffer();
        }
        
        
    }));

    return {
        session,
        audioAssets
    };
  }


  export const openSetlistZip = async (setlistZipBlob) => {
    // console.log(setlistZipBlob);
    
  
    const zipReader = new zip.ZipReader(new zip.Uint8ArrayReader(new Uint8Array(setlistZipBlob)));
    const entries = await zipReader.getEntries();

    let sessionsObject = {};

    await Promise.all(entries.filter(entry=> !entry.filename.includes('__MACOSX')).map(async (entry, index) => {
        if (entry.filename.includes('.session')) {
            const sessionAsset = await entry.getData(new zip.BlobWriter("application/zip"));
            sessionsObject[entry.filename] = await sessionAsset.arrayBuffer();
        }
    }));

    return sessionsObject;
  }